import React from "react";
import { CitySelect } from "react-country-state-city";

const CityInput = ({ countryId, stateId, placeholder, error, onChange }) => (
  <div className="form-group">
    <CitySelect
      countryid={countryId}
      stateid={stateId}
      containerClassName={`form-control state ${error ? "error-field" : ""}`}
      inputClassName=""
      autoComplete="nope"
      placeHolder={placeholder}
      onChange={onChange}
    />
    {error && (
      <span className="error">{error}</span>
    )}
  </div>
);

export default CityInput;
